<template>
  <v-list-item
    :href="href"
    :rel="href && href !== '#' ? 'noopener' : undefined"
    :target="href && href !== '#' ? '_blank' : undefined"
    :to="item.to"
    :active-class="`amber accent-4 white--text`"
    :class="group ? 'sub-item' : ''"
    v-if="item.permission ? GET_PERMISSION(item.permission) : true"
  >
    <v-list-item-icon v-if="item.icon">
      <v-icon>{{ item.icon }}</v-icon>
    </v-list-item-icon>

    <v-list-item-content v-if="item.title">
      <v-list-item-title>{{ item.title }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import { mapGetters } from "vuex";
import Themeable from "vuetify/lib/mixins/themeable";

export default {
  name: "BaseItem",

  mixins: [Themeable],

  props: {
    item: {
      type: Object,
      default: () => ({
        href: undefined,
        icon: undefined,
        title: undefined,
        to: undefined,
      }),
    },
    text: {
      type: Boolean,
      default: false,
    },
    group: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters(["GET_PERMISSION"]),
    href() {
      return this.item.href || (!this.item.to ? "#" : undefined);
    },
  },
  beforeMount() {},
};
</script>

<style scoped>
.sub-item {
  margin-left: 10px;
}
</style>
